export const GRECAPTCHA_SITEKEY = '6LdlcRQTAAAAACrAsSMxFTRz4UNJorgVK09t_K8_';
export const GRECAPTCHA_INPUT_NAME = 'g-recaptcha-response';
